/* eslint-disable max-lines-per-function */
import * as React from "react";
import { TextField, Grid, MenuItem } from "@mui/material";
import { RadioBasic } from "components/common/form";
import styles from "./batchActions.module.css";

export type LogCallStateValues = {
  reason: string;
  outcome: string;
  note: string;
}

const outcomeOptions = [
  "No answer",
  "Not in service",
  "Left Voicemail",
  "Spoke to Applicant",
  "Spoke to Applicant's Representative",
  "Left message with someone else",
  "Other",
];

const reasonOptions = [
  "Calling about a vacancy",
  "Calling to schedule interview",
  "Calling to update information",
  "Other",
];

type Props = {
  phones: {
    type: string;
    number: string;
  }[];
  onChange: (input: LogCallStateValues) => void;
  isShowing: boolean;
  fieldErrors: { outcome: string };
}

const LogCallForm: React.FC<Props> = (props) => {
  const {
    phones,
    onChange,
    isShowing,
    fieldErrors,
  } = props;

  const [outcome, setOutcome] = React.useState("");
  const [reason, setReason] = React.useState("");
  const [note, setNote] = React.useState("");


  return (
    <div className={isShowing ? "" : styles.hideView} style={{ width: "100%" }}>
      <Grid size={{ xs: 12 }}>
        <div className={styles.actionViewLabel}>Log a Call</div>

        <form onSubmit={(e) => e.preventDefault()}>
          <div className={styles.logCallPhones}> {
            phones.map((phone, i) => (
              <RadioBasic
                label={`${phone.type}: ${phone.number}`}
                name={phone.type}
                value={phone.number}
                defaultChecked={i === 0}
                key={`${phone.type}: ${phone.number}`}
              />
            ))
          }
          </div>

          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                id="log-call-outcome"
                select
                fullWidth
                required
                className={styles.marginRight}
                label="Outcome"
                value={outcome}
                error={Boolean(fieldErrors.outcome)}
                helperText={fieldErrors.outcome}
                onChange={(e) => {
                  const value = e.target.value as string;
                  setOutcome(value);
                  onChange({ reason, outcome: value, note });
                }}
              >
                <MenuItem disabled value="">
                  Select Outcome *
                </MenuItem>
                {outcomeOptions.map((value, i) => (
                  <MenuItem key={i} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                select
                fullWidth
                id="log-call-reason"
                label="Reason"
                value={reason}
                onChange={(e) => {
                  const value = e.target.value as string;
                  setReason(value);
                  onChange({ reason: value, outcome, note });
                }}
              >
                <MenuItem disabled value="">
                  Select Reason
                </MenuItem>
                {reasonOptions.map((value, i) => (
                  <MenuItem key={i} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Call Notes"
                placeholder="Recap your call..."
                multiline
                fullWidth
                variant="outlined"
                value={note}
                onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                  setNote(e.target.value);
                  onChange({ reason, outcome, note: e.target.value });
                }}
              />
            </Grid>
          </Grid>
        </form>

      </Grid>
    </div>
  );
};

export default LogCallForm;
